import { createFileRoute } from "@tanstack/react-router";
import ImportAutovitListingsPage from "@/pages/admin/ImportAutovitListings";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/import-autovit-listings/")({
  head: () => routeHead("/admin/import-autovit-listings/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <ImportAutovitListingsPage />
  );
}
